
export default {
  name: "BlogHero",
  props: {
    title: String,
    description: String,
  },
}
